import React, { useEffect, useState } from "react";
import { MdErrorOutline } from "react-icons/md";
import { useToast } from "../../controls/Toast/ToastService";
import Container from "../../base/Container";
import Card from "../../controls/Card";
import { GetById } from "../../../configurations/crud/opdCentersCrud";
import LoadingContainer from "../../controls/LoadingContainer";
import StatusContainer from "../../controls/StatusContainer";
import { CiLocationArrow1 } from "react-icons/ci";
import { EDoctorStatusBg, GetEDoctorStatusName } from "../../../configurations/enums/EDoctorStatus";
import User from "../users/User";
import { useNavigate, useParams } from "react-router-dom";
import MasterPage from "../MasterPage";
import { IoMdAdd } from "react-icons/io";
import moment from "moment";
import { GetEOpdDaysName } from "../../../configurations/enums/EOpdDays";
import AddOpdOnline from "../opdlive/AddOpdOnline";
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import useGlobalLoader from "../../../configurations/useGlobalLoader";

export default function CenterById() {
  const { start, end } = useGlobalLoader()
  const [opdCenters, setOpdCenter] = useState();
  const [loding, setLoding] = useState(false);
  const toast = useToast();
  const { centerId } = useParams()
  const [user, setUser] = useState();
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [centerName, setCenterName] = useState()
  const [lodingCrud, setLodingCrud] = useState(false)
  const navigate = useNavigate()
  const TODAYS_DATE = new Date()

  useEffect(() => {
    getAllOpdCenters()
  }, []);

  function getAllOpdCenters() {
    setLoding(true);
    start()
    GetById(centerId)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setOpdCenter(mdata.data);
        } else {
          setOpdCenter();
          toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setOpdCenter();
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  const doRefresh = () => {
    getAllOpdCenters()
  }

  const addOpdOnline = (param, setValues) => {
    setLodingCrud(true)
    start()
    opdRegisteredCrud.AddOnline(param).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setValues({
          opdCenterId: centerId,
          patientName: "",
          mobile: "",
          bloodGroup: "",
          bloodPressure: "",
          weight: "",
          age: "",
          type: 0,
          note: "",
          cityId: "",
          stateId: "",
          patientAddress: ""
        })
        setIsOpenAdd(false)
        //GetTodaysConfirmed()
        navigate(`/checkregister/${mdata.data.id}`)
        toast.open("Opd added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }
  return (
    <MasterPage>
      {
        !loding ?
          <>
            <div className="w-full flex-row md:flex px-2 pb-3 ">
              <div class="w-full md:w-3/12 md:mx-2">
                {opdCenters && opdCenters.user && <User user={opdCenters.user} isBorder={true} borderColor='border-green-300' isBack={true} isRefresh={true} doRefresh={doRefresh} title={"OPD Centers"} />}
              </div>
              <div class="my-4"></div>

              <div class="flex flex-col space-y-5  w-full md:w-9/12 md:mx-2 ">

                <>
                  {opdCenters &&
                    <div onClick={() => {
                      if (opdCenters.isRegisterOnline == 1) {
                        setCenterName(opdCenters.centerName);
                        setIsOpenAdd(!isOpenAdd);
                      }
                    }} class="w-full md:mx-2 cursor-pointer">
                      <Card isBorder={true} borderColor='border-sky-300' title={opdCenters.centerName}>
                        <div class="text-gray-700">
                          <div class="grid text-sm">
                            {opdCenters.isRegisterOnline == 0 ?
                              <>
                              </>
                              :
                              opdCenters.opdType == 0 ?
                                <div class="flex">
                                  <div class="w-4/12 px-4 py-2 font-semibold">Register Appointment</div>
                                  <div class="w-8/12 px-4 py-2">{moment(opdCenters.startPuttingAppointment).format("LT")} - {moment(opdCenters.endPuttingAppointment).format("LT")}</div>
                                </div>
                                :
                                <>
                                  <div class="flex">
                                    <div class="w-4/12 px-4 py-2 font-semibold">Register Appointment </div>
                                    <div class="w-8/12 px-4 py-2">{moment(TODAYS_DATE).format("DD/MM/YYYY")} to {moment(TODAYS_DATE.setDate(TODAYS_DATE.getDate() + parseInt(opdCenters.byDaysCount))).format("DD/MM/YYYY")}</div>
                                  </div>
                                </>
                            }
                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">OPD Timing</div>
                              <div class="w-8/12 px-4 py-2">{moment(opdCenters.opdStartTime).format("LT")} - {moment(opdCenters.opdEndTime).format("LT")}</div>
                            </div>
                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Opens</div>
                              <div class="w-8/12 px-4 py-2 space-x-1">
                                {
                                  opdCenters.opdDays.split(',').map((opdCenters, index) =>
                                    <>
                                      {index != 0 && " ,"}{GetEOpdDaysName(opdCenters.trim())}
                                    </>
                                  )
                                }</div>
                            </div>
                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Address</div>
                              <div class="w-8/12 px-4 py-2">{opdCenters.address},{opdCenters.city.name}, {opdCenters.city.state.name}, Phone {opdCenters.phone}</div>
                            </div>

                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Doctor Status</div>
                              <div class="w-8/12 px-4 py-2"><StatusContainer bg={EDoctorStatusBg(opdCenters.doctorStatus)} text={GetEDoctorStatusName(opdCenters.doctorStatus)} /></div>
                            </div>
                            {opdCenters.details && <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Details</div>
                              <div class="w-8/12 px-4 py-2">{opdCenters.details}</div>
                            </div>}
                            {opdCenters.isRegisterOnline == 0 ?
                              <></>
                              :
                              <div className="flex justify-end">
                                <button
                                  type="button"
                                  title="Register"
                                  onClick={() => {
                                    setCenterName(opdCenters.centerName);
                                    setIsOpenAdd(!isOpenAdd);
                                  }}
                                  className="flex items-center gap-1 px-3 py-2 text-white bg-sky-500 rounded-lg shadow-md hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-400 active:bg-sky-700 transition-all duration-200"
                                >
                                  <IoMdAdd className="text-lg" />
                                  <span className="text-sm font-medium">Create Appointment</span>
                                </button>
                              </div>
                            }

                          </div>
                        </div>
                      </Card>
                    </div>
                  }
                  <div class="my-4"></div>
                </>

              </div>
            </div>
          </>
          :
          <div className="w-full flex-row md:flex px-2 pb-3 ">
            <div class="w-full md:mx-2">
              <Card isBorder={true} borderColor='border-green-300'>
                <LoadingContainer />
              </Card>
            </div>
          </div>
      }

      {opdCenters && <AddOpdOnline title={`Create Appointment for ${centerName}`} centerData={opdCenters} addOpdOnline={addOpdOnline} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} centerId={centerId} />}

    </MasterPage>
  );
}
